import { composeItemAttributesUpdate } from '../../modules/katapult-job/KatapultJobUpdateComposers.js';
import { createReplacingItemAttributesMutation } from '../../modules/katapult-job/KatapultJobUtilities.js';

/**
 * Removes a hard-coded list of all permit status attributes.
 * @param {Object} node - The data object for the node.
 * @param {String} nodeId - The ID of the node.
 * @param {Object} jobStyles - The job styles object.
 * @param {Object} [update] - The object for updating node attributes.
 * @returns {Object} - The updated object for updating node attributes.
 */
export function removePermitStatusAttributes(node, nodeId, jobStyles, update = {}) {
  // Get all permit attributes
  const permitStatusAttributes = ['PPL_ROW_status', 'PennDOT_permit_status', 'municipal_permit', 'RxR_permit_status'];
  const attributes = {};
  for (let attributeName of permitStatusAttributes) {
    let nodeAttributeValue = Object.values(node.attributes[attributeName] || {})[0];
    // Only delete these attributes if the status is set to "Unnecessary" or blank, otherwise set it to "canceled"
    if (permitStatusAttributes.includes(attributeName) && nodeAttributeValue && nodeAttributeValue != 'Unnecessary')
      attributes[attributeName] = { app_added: 'Canceled' };
    // Only delete the attribute if it exists on the node
    else if (nodeAttributeValue !== undefined) attributes[attributeName] = null;
  }
  if (!Object.keys(attributes).length) return update;
  const attributeChanges = createReplacingItemAttributesMutation(node.attributes, attributes);
  const permitUpdate = composeItemAttributesUpdate('node', nodeId, node, attributeChanges, { jobStyles });
  Object.assign(update, permitUpdate);
  return update;
}
